module.exports = __webpack_public_path__ + "79e674aa3331a119b733a1d1aabb4afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta/icon_next_dark.png
// module id = 816
// module chunks = 0 1